import * as React from "react";
import { Toolbar } from "@base-ui-components/react/toolbar";
import { ToggleGroup } from "@base-ui-components/react/toggle-group";
import { Toggle } from "@base-ui-components/react/toggle";

export default function ToolbarTop({ callInfo }) {
  return (
    <Toolbar.Root className="flex flex-col lg:flex-row w-full items-center gap-px rounded-md border border-gray-200 bg-gray-50 p-0.5">
      <ToggleGroup className="flex gap-1" aria-label="Alignment">
        <Toolbar.Button
          render={<Toggle />}
          aria-label="Align left"
          value="align-left"
          className="flex gap-1 h-8 items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900"
        >
          <p className="text-gray-600 font-semibold">Eng. ID:</p>
          <p className="text-gray-500"> {callInfo?.engagement_id}</p>
        </Toolbar.Button>
      </ToggleGroup>
      <Toolbar.Separator
        orientation="vertical"
        className="m-1 h-4 w-px bg-gray-300 hidden lg:block"
      />
      <Toolbar.Separator
        orientation="horizontal"
        className="m-1 w-6 bg-gray-300 block lg:hidden h-px"
      />
      <ToggleGroup className="flex gap-1" aria-label="Alignment">
        <Toolbar.Button
          render={<Toggle />}
          aria-label="Align left"
          value="align-left"
          className="flex gap-1 h-8 items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900"
        >
          <p className="text-gray-600 font-semibold">Client:</p>
          <p className="text-gray-500"> {callInfo?.customer_name}</p>
        </Toolbar.Button>
      </ToggleGroup>
      {/* <Toolbar.Separator className="m-1 h-4 w-px bg-gray-300" /> */}
      {/* <ToggleGroup className="flex gap-1" aria-label="Alignment">
        <Toolbar.Button
          render={<Toggle />}
          aria-label="Align right"
          value="align-right"
          className="flex gap-1 h-8 items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900"
        >
          <p className="text-gray-600 font-semibold">Customer Number:</p>
          <p className="text-gray-500"> {callInfo?.consumer_number}</p>
        </Toolbar.Button>
      </ToggleGroup> */}
      <Toolbar.Separator
        orientation="vertical"
        className="m-1 h-4 w-px bg-gray-300 hidden lg:block"
      />
      <Toolbar.Separator
        orientation="horizontal"
        className="m-1 w-6 bg-gray-300 block lg:hidden h-px"
      />
      <ToggleGroup className="flex gap-1" aria-label="Alignment">
        <Toolbar.Button
          render={<Toggle />}
          aria-label="Align right"
          value="align-right"
          className="flex gap-1 h-8 items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900"
        >
          <p className="text-gray-600 font-semibold">Flow:</p>
          <p className="text-gray-500"> {callInfo?.flow_name}</p>
        </Toolbar.Button>
      </ToggleGroup>
    </Toolbar.Root>
  );
}
